import defaultContent from '../../../content/platformList';
import { useTranslation } from 'react-i18next';
import Title from '../../common/Title/Title';
import Search from '../../common/Search/Search';
import Button from '../../common/Button/Button';
// import Table from "../../common/Table/Table";
// import { mockPlatformListTableData, mockPlatformListTableHeader } from "../../../mocks/data";

export const PlatformList = () => {
  const { t } = useTranslation(['platformList']);
  const title = t('platformList', defaultContent['platformList']).toString();

  const platformList = (
    <div className="container">
      <Title text={title} />
      <div className="h-3"></div>
      <div className="row">
        <div className="column-one right">
          <span className="w-3">
            <Search
              onSearch={function (query: string): void {
                throw new Error('Function not implemented.');
              }}
            />
          </span>

          <span className="spacing-half-one"></span>
          <Button
            text="Add Platform"
            color="primary-black"
            disabled={false}
            action={function (): void {
              alert('Function not implemented.');
            }}
          />
          <span className="spacing-half-one"></span>

          <Button
            text="Bulk Process"
            color="primary-black"
            disabled={false}
            action={function (): void {
              alert('Function not implemented.');
            }}
          />
        </div>
      </div>
      <div className="h-2"></div>
      {/* <Table headers={mockPlatformListTableHeader} data={mockPlatformListTableData} /> */}
      <div className="h-3"></div>
    </div>
  );

  return <>{platformList}</>;
};

export default PlatformList;
